import React, { useEffect } from "react";
import ReactSignatureCanvas from "react-signature-canvas";
import UploadFile from "../components/elements/validation/UploadFile";
import Checkbox from "../components/UI/Checkbox";
import Divider from "../components/UI/Divider";
import Header from "../components/UI/Header";
import env from "../env/env.json";

const Validation = ({
  formData,
  setFormData,
  handleSignatureEnd,
  clearSignature,
  sigRef,
  handleChange,
  handleChangeFiles,
  handleResetFiles,
  tooltip,
  inputFocus,
  page,
  handleResetInputFiles,
  loading,
}) => {
  const annexe_2 = env.annexe_2;
  const annexe_3 = env.annexe_3;
  const CGU = env.CGU;
  const RGPD = env.RGPD;
  let files = {};

  useEffect(() => {
    if (!formData.files) {
      document.querySelectorAll(".files-upload").forEach((el) => {
        files[el.name] = [];
      });
      setFormData({ ...formData, files });
    }
  }, []);

  //** Permet de télécharger les pièces jointes lorsque les conditions de téléchargement sont validées */
  document.querySelectorAll(".files-upload").forEach((input) => {
    if (
      formData.Check11 !==
      "J'accepte les conditions de téléchargement des pièces jointes."
    ) {
      input.setAttribute("disabled", true);
    } else {
      input.removeAttribute("disabled");
    }
  });

  return (
    <>
      {loading && (
        <div
          className="modal modal-sm fade show d-block"
          tabIndex="-1"
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body d-flex justify-content-center text-black">
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                &nbsp;Chargement en cours ...
              </div>
            </div>
          </div>
        </div>
      )}
      <Header title="4. Validation de la demande" />
      {page < 5 && (
        <>
          <div>
            <div className="row d-flex flex-column align-items-center mb-5">
              <i className="fas fa-file-download fa-7x"></i>
              <h5 className="text-center">Pièces justificatives à fournir</h5>
            </div>
            <div className="alert alert-danger text-center">
              <p>
                Cliquez sur le bouton "Ajouter une pièce justificative" pour
                sélectionner le(s) fichier(s) à transmettre. Les documents
                envoyés doivent être au format PDF, JPEG, JPG ou PNG et d'une
                taille maximale de 8 Mo par fichier.
              </p>
              <p className="text-center">
                Si besoin,&nbsp;
                <a href={annexe_3} target="blank" rel="nofollow">
                  cliquez ici&nbsp;
                </a>
                pour télécharger le justificatif de mandat (annexe 3).
              </p>
            </div>
          </div>
          <Divider />
          <div className="background--warning p-3">
            <p>
              Afin de traiter votre demande, nous devons collecter certaines
              informations personnelles, y compris des pièces jointes que vous
              devrez télécharger.
            </p>
            <p>
              Nous vous informons que toutes les pièces jointes que vous
              téléchargez seront stockées sur nos serveurs en France tout au
              long du processus de complétion du formulaire.
              <br />
              Dans le cas où vous ne finalisez pas le formulaire, toutes les
              données et pièces jointes que vous avez téléchargées seront
              automatiquement supprimées de nos serveurs après 120 minutes.
              Toutefois, si vous finalisez le formulaire et soumettez votre
              demande, les pièces jointes seront stockées dans nos archives
              conformément à notre politique de conservation des données.
            </p>
            <p>
              En cliquant sur le bouton "J'accepte", vous donnez votre
              consentement explicite pour que nous collections, stockions et
              utilisions vos données personnelles conformément à notre politique
              de confidentialité (
              <a href={RGPD} target="_blank" rel="noreferrer">
                lien vers politique RGPD
              </a>
              ).
              <br />
              Si vous ne donnez pas votre consentement, vous ne pourrez pas
              soumettre votre demande.
            </p>
            <Checkbox
              checkClassName="page-4-required"
              name="Check11"
              value="J'accepte les conditions de téléchargement des pièces jointes."
              onInput={inputFocus}
              handleChange={handleChange}
              label="J'accepte les conditions de téléchargement des pièces jointes."
              checked={
                formData.Check11 ===
                "J'accepte les conditions de téléchargement des pièces jointes."
              }
            />
          </div>
        </>
      )}
      {/* uniquement pour l'intégration manuelle */}
      {/* <div className="row mt-5">
        <UploadFile
          className={"col-12 col-md-6"}
          inputClassName={"form-control files-upload getLabel"}
          htmlFor={"input-file-ProDossierPapier"}
          label="Dossier papier"
          onChange={handleChangeFiles}
          onInput={inputFocus}
          inputName={"ProDossierPapier"}
          buttonId={"LM"}
          formData={formData}
          onClick={handleResetInputFiles}
        />
        <div className="col-12 col-md-6 position-relative">
          <label htmlFor="ProDateDossierPapier" className="form-label fw-bold">
            Date de réception du dossier papier
          </label>
          <input
            className="form-control page-4-required inputReg date"
            type="date"
            name="ProDateDossierPapier"
            value={formData.ProDateDossierPapier || ""}
            onChange={handleChange}
            onInput={inputFocus}
            required={formData.ProDateDossierPapier === ""}
          />
          <div className="invalid-tooltip">
            Veuillez entrer une date de dépôt
          </div>
        </div>
      </div> */}
      <section className="mt-5">
        {formData.MandataireOuiNon === "Oui" && (
          <>
            <UploadFile
              className={"row mt-4"}
              inputClassName={"page-4-required"}
              label="Pièce justificative d'identité en cours de validité (CNI, passeport...) du mandataire"
              onChange={handleChangeFiles}
              onInput={inputFocus}
              inputName={"CNI_Mandat"}
              buttonId={"PNI_MANDAT"}
              onClick={handleResetInputFiles}
              formData={formData}
              required
            />
            <UploadFile
              className={"row mt-4"}
              inputClassName={"page-4-required"}
              label="L'annexe signée justifiant de ce mandat (annexe 3)"
              onChange={handleChangeFiles}
              onInput={inputFocus}
              inputName={"MandataireAnnexe"}
              buttonId={"LM"}
              onClick={handleResetInputFiles}
              formData={formData}
              required
            />
          </>
        )}
        {formData.PersonneType === "Une personne physique" && (
          <UploadFile
            className={"row mt-4"}
            inputClassName={"page-4-required"}
            label="Pièce justificative d'identité en cours de validité (CNI, passeport...) du/des propriétaire(s)"
            onChange={handleChangeFiles}
            onInput={inputFocus}
            inputName={"CNI"}
            buttonId={"PNI_M"}
            onClick={handleResetInputFiles}
            formData={formData}
            required
          />
        )}
        {formData.PersonneType === "Une personne morale" && (
          <UploadFile
            className={"row mt-4"}
            inputClassName={"page-4-required"}
            label="Copie des statuts ou extrait de Kbis à jour mentionnant une activité compatible avec l'objet du changement d'usage."
            onChange={handleChangeFiles}
            onInput={inputFocus}
            inputName={"Kbis"}
            buttonId={"KBIS_SDD"}
            onClick={handleResetInputFiles}
            formData={formData}
            required
          />
        )}
      </section>
      <section>
        {formData.ProPremierCU ===
          "Oui, je souhaite obtenir la reconduction de ma première autorisation pour 2 ans suplémentaires" && (
          <UploadFile
            className={"row mt-4"}
            inputClassName={"page-4-required"}
            label="Copie de la précédente autorisation"
            onChange={handleChangeFiles}
            onInput={inputFocus}
            inputName={"ProCopieAutorisation"}
            buttonId={"ARRETE_INITIAL"}
            onClick={handleResetInputFiles}
            formData={formData}
          />
        )}
      </section>
      <section>
        {formData.LocPrimoAccess === "Oui" && (
          <UploadFile
            className={"row mt-4"}
            inputClassName={"page-4-required"}
            label="Copie de l'acte authentique de vente"
            onChange={handleChangeFiles}
            onInput={inputFocus}
            inputName={"CopieActeVente"}
            buttonId={"ACTE_VENTE"}
            onClick={handleResetInputFiles}
            formData={formData}
            required
          />
        )}
        <UploadFile
          className={"row mt-4"}
          inputClassName="page-4-required"
          label="Plan côté du local objet de la demande, daté et signé par le(s) demandeur(s), avec mention de la surface habitable (conformément à l'article R.156-1 du Code de la Construction et de l'Habitation)."
          onChange={handleChangeFiles}
          onInput={inputFocus}
          inputName={"LocPlan"}
          buttonId={"PLAN_C_LOCAL"}
          onClick={handleResetInputFiles}
          formData={formData}
          required
        />
        <UploadFile
          className={"row mt-4"}
          inputClassName="page-4-required"
          label="Titre d'occupation ou attestation de propriété du demandeur"
          onChange={handleChangeFiles}
          onInput={inputFocus}
          inputName={"LocAvisTaxe"}
          buttonId={"TITRE_PROPRI"}
          onClick={handleResetInputFiles}
          formData={formData}
          required
        />
        {formData.LocMandantStatut ===
          "Bénéficiaire d'une promesse de vente" && (
          <UploadFile
            className="row mt-4"
            inputClassName="page-4-required"
            label="Copie de la promesse de vente."
            onChange={handleChangeFiles}
            onInput={inputFocus}
            inputName={"LocCopieVente"}
            buttonId={"PROM_VENTE"}
            onClick={handleResetInputFiles}
            formData={formData}
            required
          />
        )}
        {(formData.LocMandantStatut === "Locataire" ||
          formData.LocMandantStatut === "Occupant à titre gratuit" ||
          formData.LocMandantStatut ===
            "Bénéficiaire d'une promesse de vente") && (
          <UploadFile
            className="row mt-4"
            inputClassName="page-4-required"
            htmlFor={"LocFormEngagement"}
            label={
              <>
                {"« Autorisation du propriétaire »"}{" "}
                <a href={annexe_2} target="blank" rel="nofollow">
                  annexe 2
                </a>{" "}
                {
                  "rempli et signé par le propriétaire : accord du propriétaire si le demandeur est locataire ou occupant à titre gratuit et attestation justifiant que le règlement de copropriété ne s'oppose pas au changement d'usage."
                }
              </>
            }
            onChange={handleChangeFiles}
            onInput={inputFocus}
            inputName={"LocFormEngagement"}
            buttonId={"ENGAGEMENT_PROP"}
            onClick={handleResetInputFiles}
            formData={formData}
            required
          />
        )}
      </section>
      <div
        className={
          page === 5 ? "d-none" : "d-flex justify-content-center pt-5 d-block"
        }
      >
        <button
          type="button"
          className="btn btn-outline-warning btn-md"
          data-bs-toggle="modal"
          data-bs-target="#ModalSupp"
        >
          Réinitialiser les pièces jointes
        </button>
        <div
          className="modal fade"
          id="ModalSupp"
          tabIndex="-1"
          aria-labelledby="ModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header border-0">
                <h5 className="modal-title">Confirmer la suppression</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <p>
                  Êtes-vous sur de vouloir supprimer toutes les pièces jointes ?
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-outline-warning btn-md"
                  data-bs-dismiss="modal"
                >
                  Annuler
                </button>
                <button
                  type="button"
                  className="btn btn-warning btn-md"
                  onClick={handleResetFiles}
                  data-bs-dismiss="modal"
                >
                  Supprimer
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Divider />
      <section className="background--warning p-4">
        <p>
          Vous êtes sur le point de déposer votre demande de changement d’usage
          à caractère personnel (ou usage mixte).
        </p>
        <p>
          Veuillez vérifier le récapitulatif de votre demande avant de procéder
          à sa validation.
        </p>
        <p>
          Si nécessaire, vous pouvez revenir en arrière à l'aide du bouton
          "Retour" pour modifier les informations saisies.
        </p>
        <p>
          En déposant votre demande de changement d'usage à caractère personnel
          (ou usage mixte) à l'aide du présent formulaire vous acceptez les{" "}
          <a href={CGU} target="_blank" rel="noreferrer">
            Conditions Générales d'Utilisation du service de dépôt en ligne.
          </a>
        </p>
      </section>
      <Divider />
      <section className="background--warning p-4">
        <p className="fw-bold">
          Veuillez accepter les CGU&nbsp;:&nbsp;
          <span className="text-danger">*</span>
        </p>
        <Checkbox
          checkClassName="page-4-required"
          name="Check1"
          value="Je confirme avoir lu, compris et accepté les CGU et je souhaite déposer une demande de changement d'usage à caractère personnel (ou usage mixte)."
          inputFocus={inputFocus}
          handleChange={handleChange}
          label="Je confirme avoir lu, compris et accepté les CGU et je souhaite déposer une demande de changement d'usage à caractère personnel (ou usage mixte)."
          checked={
            formData.Check1 ===
            "Je confirme avoir lu, compris et accepté les CGU et je souhaite déposer une demande de changement d'usage à caractère personnel (ou usage mixte)."
              ? true
              : false
          }
        />
        <Checkbox
          checkClassName="page-4-required"
          label="Je certifie sur l'honneur l'exactitude des informations fournies dans cette demande de changement d'usage à caractère personnel (ou usage mixte) déposée en ligne."
          name="Check2"
          value="Je certifie sur l'honneur l'exactitude des informations fournies dans cette demande de changement d'usage à caractère personnel (ou usage mixte) déposée en ligne."
          checked={
            formData.Check2 ===
            "Je certifie sur l'honneur l'exactitude des informations fournies dans cette demande de changement d'usage à caractère personnel (ou usage mixte) déposée en ligne."
              ? true
              : false
          }
          handleChange={handleChange}
          inputFocus={inputFocus}
        />
        <Checkbox
          checkClassName="page-4-required"
          label="Je m'engage à fournir toutes les pièces justificatives complémentaires qui me seraient demandées ultérieurement."
          name="Check3"
          value="Je m'engage à fournir toutes les pièces justificatives complémentaires qui me seraient demandées ultérieurement."
          checked={
            formData.Check3 ===
            "Je m'engage à fournir toutes les pièces justificatives complémentaires qui me seraient demandées ultérieurement."
              ? true
              : false
          }
          handleChange={handleChange}
          inputFocus={inputFocus}
        />
        <Checkbox
          checkClassName="page-4-required"
          label="J'accepte de recevoir l'accusé de réception de ma demande de manière dématérialisée."
          name="Check4"
          value="J'accepte de recevoir l'accusé de réception de ma demande de manière dématérialisée."
          checked={
            formData.Check4 ===
            "J'accepte de recevoir l'accusé de réception de ma demande de manière dématérialisée."
              ? true
              : false
          }
          handleChange={handleChange}
          inputFocus={inputFocus}
        />
        <Checkbox
          checkClassName={"page-4-required"}
          label="Je permettrai aux agents dûment habilités de la commune la visite des locaux objets de la demande de changement d'usage."
          name="Check12"
          value="Je permettrai aux agents dûment habilités de la commune la visite des locaux objets de la demande de changement d'usage."
          checked={
            formData.Check12 ===
            "Je permettrai aux agents dûment habilités de la commune la visite des locaux objets de la demande de changement d'usage."
              ? true
              : false
          }
          handleChange={handleChange}
          inputFocus={inputFocus}
        />
      </section>
      {page === 5 && (
        <div className="d-flex flex-column align-items-start position-relative mt-5">
          <p className="fw-bold">Votre signature&nbsp;:&nbsp;*</p>
          <ReactSignatureCanvas
            ref={sigRef}
            name="Signature"
            penColor="black"
            canvasProps={{ className: "signatureCanva" }}
            onEnd={handleSignatureEnd}
          />
          <div
            className={
              (formData.Signature === null || formData.Signature === "") &&
              tooltip === true
                ? "invalid-tooltip d-block"
                : "d-none"
            }
          >
            Veuillez signer le document
          </div>
          <button
            type="button"
            className="btn btn-warning btn-md"
            onClick={clearSignature}
          >
            Effacer
          </button>
        </div>
      )}
    </>
  );
};

export default Validation;
